import { AnyAction } from 'redux'
import { createAction } from 'redux-actions'
import { ThunkDispatch } from 'redux-thunk'
import { RootState } from '../../reducers'
import { post, url } from '../../../javascripts/http'
import { isHasBasicInfo } from '../../../javascripts/generic'
import { actionLogoutSuccess } from '../user'
import { OrganizationService } from '../../../api/base/organization/organization'
import { MobileAccountService } from '../../../api/base/account/mobile_account'
import { ScannerService, OrganizationType } from '../../../api/scanner/scanner_service'
import { message } from 'antd'
import { PressureService } from '../../../api/pressure/pressure_service'

let organizationService = new OrganizationService(url, post);
let mobileAccountService = new MobileAccountService(url, post);
let scannerService = new ScannerService(url, post);
let pressureService = new PressureService(url, post);

// 发送短信
async function sendNote (isRegister, data) {
    let organizationType = OrganizationType.ORGANIZATION_TYPE_SENNOTECH_STORE;
    try {
        if(isRegister) {
            // 已经注册的模版
            await scannerService.sendSmsNotificationWhenAccountRegistered({
                countryCode: '86',
                mobileNumber: data.mobileNumber,
                organizationType: organizationType,
                name: '',
                organizationName: data.name,
            });
        }
        else {
            // 没有注册过的模版
            await scannerService.sendSmsNotificationWhenAccountPreRegistration({
                countryCode: '86',
                mobileNumber: data.mobileNumber,
                organizationType: organizationType,
                name: '',
                organizationName: data.name,
                // accountGroupName: '管理员',
                username: data.mobileNumber,
                initPassword: '123456'
            });
        }
    } catch(error) {

    }
}

export function actionCreateStore (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        try {
            let orgGroupId = getState().user.orgGroupId;
            if(orgGroupId === '') return ;
            let res_account;
            let isRegister = true;
             try {
                 // 根据手机号 查用户id
                res_account = await mobileAccountService.getAccountId({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86'
                });
                let res_ex = await mobileAccountService.checkPasswordExistByClient({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86',
                    client: 'scanner.institution.store'
                });
                if(!res_ex.exist) {
                    isRegister = false;
                    await mobileAccountService.setPasswordForMobile({
                        mobileNumber: data.mobileNumber,
                        countryCode: '86',
                        password: '123456',
                    })
                }

             } catch (error) {
                 //密码注册
                isRegister = false;
                res_account = await mobileAccountService.registerByPassword({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86',
                    password: '123456',
                    client: 'scanner.institution.store'
                })
             }

            // 创建组织 代表门店
            let data_org = {
                createOrganization: {
                    organizationGroupId: +orgGroupId,
                    name: data.name,
                    description: data.name,
                    type: 'scanner.institution.store'
                }
            }
            let res_org = await organizationService.createOrganization(data_org);

            // 创建用户组 管门店下的超管 添加
            let data_accountGroup = {
                createAccountGroup: {
                    name: 'superAdmin',
                    displayName: '超管',
                    description: data.name,
                    organizationId: res_org.organizationId
                }
            }
            let res_accountGroup = await organizationService.createAccountGroup(data_accountGroup);
            await organizationService.addAccountToAccountGroupByAccountId({
                accountGroupId: res_accountGroup.accountGroupId,
                accountId: res_account.accountId
            });

            // 创建用户组 管门店下的管理员
            data_accountGroup.createAccountGroup.name = 'admin';
            data_accountGroup.createAccountGroup.displayName = '管理员';
            await organizationService.createAccountGroup(data_accountGroup);

            // 创建用户组 管门店的店员
            data_accountGroup.createAccountGroup.name = 'staff';
            data_accountGroup.createAccountGroup.displayName = '员工';
            await organizationService.createAccountGroup(data_accountGroup);

            // 添加使用时间 扫脚仪
           if(data.startTimeScan && data.endTimeScan) {
                await scannerService.updateOrganizationLicence({
                    organizationLicence: {
                        organizationId: res_org.organizationId,
                        startTimestamp: data.startTimeScan,
                        endTimestamp: data.endTimeScan
                    }
                })
           }

            // 添加使用时间 压力版
            if(data.startTimeFeet && data.endTimeFeet) {
                await pressureService.updateOrganizationLicence({
                    organizationLicence: {
                        organizationId: res_org.organizationId,
                        startTimestamp: data.startTimeFeet,
                        endTimestamp: data.endTimeFeet
                    }
                })
            }

            dispatch(actionCreateStoreSuccess({}));
            
            // 发送短信
            sendNote(isRegister, data);

            dispatch(actionGetStoreList());
            
        } catch (error: any) {
            if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionOperateStoreFail({
                    data: '管理员账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'organization already existed.') {
                dispatch(actionOperateStoreFail({
                    data: '商户名称已存在'
                }))
            }
            else {
                dispatch(actionOperateStoreFail({
                    data: '创建失败'
                }))
            }
        }
    }
}

export const ACTION_CREATESTORE_SUCCESS = 'USER.ACTION_CREATESTORE_SUCCESS'

export interface ActionCreateStorePayload {
    
}

export const actionCreateStoreSuccess = createAction(
    ACTION_CREATESTORE_SUCCESS,
    (payload: ActionCreateStorePayload) => {
        return payload;
    }
)

// 操作失败提示 商户统一用
export const ACTION_OPERATESTORE_FAIL = 'USER.ACTION_OPERATESTORE_FAIL'

export interface ActionOperateStoreFailPayload {
    data: string
}

export const actionOperateStoreFail = createAction(
    ACTION_OPERATESTORE_FAIL,
    (payload: ActionOperateStoreFailPayload) => {
        return payload;
    }
)

export function actionGetStoreList () {
    return async(dispatch: ThunkDispatch<RootState, any, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        message.loading('数据加载中...', 0)
        try {

            let groupId = getState().user.orgGroupId;
            if(groupId == '') return ;

            // 获取组织组下的组织
            let res_org = await organizationService.getOrganizationsByOrganizationGroupIds({
                organizationGroupIds: [+groupId]
            });
            let orgGroupList = res_org.organizationGroupList[0].organizationList || [];

            let orgIds = orgGroupList.map((item) => {
                return item.id;
            }) || [];

            if(orgIds.length < 0) return 0;

             // 获取使用时间
            let res_timesScan = await scannerService.listOrganizationLicence({
                organizationIds: orgIds
            });

            let res_timesFeet = await pressureService.listOrganizationLicence({
                organizationIds: orgIds
            });
            
             // 获取超管
            let res_accountGroup = await organizationService.listAccountsByOrganizationIdsAndAccountGroupName({
                organizationIdList: orgIds,
                accountGroupNameList: ['superAdmin']
            });

            let accountIds: any[] = [];
            res_accountGroup.organizationAccountGroupAccountList.map((item) => {
                let groupList = item.accountGroupAccountList;
                if(groupList.length && groupList[0].accountIdList) {
                    accountIds = [...accountIds, groupList[0].accountIdList]
                }
            })

            accountIds = Array.from(new Set(accountIds));
            let res_account = await mobileAccountService.getMobileNumberByAccounts({
                accountIds: accountIds
            });

            let invaildCountScan = 0;
            let listScan = res_timesScan.organizationLicenceList.map((item) => {
                let obj = item;
                let org = orgGroupList.find((t) => {
                    return t.id === item.organizationId;
                }) || {};
                let times = res_timesFeet.organizationLicenceList.find((t) => {
                    return t.organizationId === item.organizationId;
                }) || {};
                if(item.endTimestamp) {
                    let now = (new Date()).valueOf();
                    let status = '已生效';
                    if(now > +item.endTimestamp) {
                        status = '已过期';
                        invaildCountScan++;
                    }
                    Object.assign(obj, org, {times}, {status});
                }

                let accountG = res_accountGroup.organizationAccountGroupAccountList.find((l) => {
                    return item.organizationId == l.organization.id;
                }) || {} as any;
                if(accountG && accountG.accountGroupAccountList) {
                    let accountId = accountG.accountGroupAccountList[0].accountIdList[0];
                    let accountGroupId = accountG.accountGroupAccountList[0].accountGroup.id;
                    let account = res_account.result.find((a) => {
                        return a.accountId === accountId
                    })|| {};
                    Object.assign(obj, account, {accountGroupId});
                }
                return {
                    ...obj
                }
            })

            let invaildCountFeet = 0;
            let listFeet = res_timesFeet.organizationLicenceList.map((item) => {
                let obj = item;
                let org = orgGroupList.find((t) => {
                    return t.id === item.organizationId;
                }) || {};
                let times = res_timesScan.organizationLicenceList.find((t) => {
                    return t.organizationId === item.organizationId;
                }) || {};
                if(item.endTimestamp) {
                    let now = (new Date()).valueOf();
                    let status = '已生效';
                    if(now > +item.endTimestamp) {
                        status = '已过期';
                        invaildCountFeet++;
                    }
                    Object.assign(obj, org, {times}, {status});
                }

                let accountG = res_accountGroup.organizationAccountGroupAccountList.find((l) => {
                    return item.organizationId == l.organization.id;
                }) || {} as any;
                if(accountG && accountG.accountGroupAccountList) {
                    let accountId = accountG.accountGroupAccountList[0].accountIdList[0];
                    let accountGroupId = accountG.accountGroupAccountList[0].accountGroup.id;
                    let account = res_account.result.find((a) => {
                        return a.accountId === accountId
                    })|| {};
                    Object.assign(obj, account, {accountGroupId});
                }
                return {
                    ...obj
                }
            })

            dispatch(actionGetStoreListSuccess({
                data: {
                    scan: {
                        list: listScan,
                        allTotal: listScan.length,
                        invalidTotal: invaildCountScan,
                        validTotal: listScan.length - invaildCountScan
                    },
                    feet: {
                        list: listFeet,
                        allTotal: listFeet.length,
                        invalidTotal: invaildCountFeet,
                        validTotal: listFeet.length - invaildCountFeet
                    }
                    
                }
            }))
           
        } catch (error) {
            console.log(error)
        }
        dispatch(actionOperateStoreFail({
            data: ''
        }))
        message.destroy();
    }
}

export const ACTION_GETSTORELIST_SUCCESS = 'USER.ACTION_GETSTORELIST_SUCCESS'

export interface ActionGetStoreListPayload {
    data: any
}

export const actionGetStoreListSuccess = createAction(
    ACTION_GETSTORELIST_SUCCESS,
    (payload: ActionGetStoreListPayload) => {
        return payload;
    }
)

export function actionGetStoreListBySearch (data, key) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        message.loading('搜索中...', 0)
        try {

            let stores = getState().store.storeList || {};
            let storeKey = stores[key] || {};
            let storeList = storeKey.list || [];
            let searchList: any[] = [];
            let isSearch = true;
            if(storeList.length && data) {
                data = data.trim();
                let arrName = storeList.filter((item) => {
                    return item.name.search(data) != -1
                }) || [];
                let arrPhone = storeList.filter((item) => {
                    return item.mobileNumber && item.mobileNumber.search(data) != -1;
                }) || [];
                searchList = [...arrName, ...arrPhone];
            }
            else {
                isSearch = false;
                searchList = [];
            }
            dispatch(actionGetStoreListBySearchSuccess({
                data: searchList,
                isSearch: isSearch
            }))
        } catch (error) {

        }
        message.destroy();
    }
}

export const ACTION_GETSTORELISTBYSEARCH_SUCCESS = 'USER.ACTION_GETSTORELISTBYSEARCH_SUCCESS'

export interface ActionGetStoreListBySearchPayload {
    data: any
    isSearch: boolean
}

export const actionGetStoreListBySearchSuccess = createAction(
    ACTION_GETSTORELISTBYSEARCH_SUCCESS,
    (payload: ActionGetStoreListBySearchPayload) => {
        return payload
    }
)

export function actionUpdateStore (odata, ndata) {
    return async(dispatch: ThunkDispatch<RootState, any, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        try {

            // 根据原信息查看是否需要更新
            console.log({odata, ndata});
            if(odata.name !== ndata.name) {
                // 更新机构名称
                await organizationService.updateOrganizationNameAndDescription({
                    organizationId: odata.id,
                    name: ndata.name
                })
            }
            if(odata.mobileNumber !== ndata.mobileNumber) {
                // 超管移除原用户 加新用户
                console.log('超管移除原用户 加新用户');
                
                let res_account;
                let isRegister = true;
                try {
                    // 根据手机号 查用户id
                    res_account = await mobileAccountService.getAccountId({
                        mobileNumber: ndata.mobileNumber,
                        countryCode: '86'
                    });
                    let res_ex = await mobileAccountService.checkPasswordExistByClient({
                        mobileNumber: ndata.mobileNumber,
                        countryCode: '86',
                        client: 'scanner.institution.store'
                    });
                    if(!res_ex.exist) {
                        isRegister = false;
                        await mobileAccountService.setPasswordForMobile({
                            mobileNumber: ndata.mobileNumber,
                            countryCode: '86',
                            password: '123456',
                        })
                    }
                } catch (error) {
                    //密码注册
                    isRegister = false;
                    res_account = await mobileAccountService.registerByPassword({
                        mobileNumber: ndata.mobileNumber,
                        countryCode: '86',
                        password: '123456',
                        client: 'scanner.institution.store',
                    })
                }

                if(odata.accountId) {
                    await organizationService.removeAccountFromAccountGroup({
                        accountGroupId: odata.accountGroupId,
                        accountId: odata.accountId,
                    });
                }

                if(res_account.accountId) {
                    await organizationService.addAccountToAccountGroupByAccountId({
                        accountGroupId: odata.accountGroupId,
                        accountId: res_account.accountId
                    })
                }

                // 发送短信
                sendNote(isRegister, ndata);
                
            }

            if(+odata.startTimeScan != ndata.startTimeScan || +odata.endTimeScan != ndata.endTimeScan) {
                // 更新使用时间
                await scannerService.updateOrganizationLicence({
                    organizationLicence: {
                        organizationId: odata.id,
                        startTimestamp: ndata.startTimeScan,
                        endTimestamp: ndata.endTimeScan
                    }
                })
            }

            if(+odata.startTimeFeet != ndata.startTimeFeet || +odata.endTimeFeet != ndata.endTimeFeet) {
                // 更新使用时间
                await pressureService.updateOrganizationLicence({
                    organizationLicence: {
                        organizationId: odata.id,
                        startTimestamp: ndata.startTimeFeet,
                        endTimestamp: ndata.endTimeFeet
                    }
                })
            }
            
            dispatch(actionUpdateStoreSuccess({
                data: {}
            }))

            message.success('更新成功', 12);

            dispatch(actionGetStoreList());

        } catch (error: any) {

            if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionOperateStoreFail({
                    data: '管理员账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'organization already existed.') {
                dispatch(actionOperateStoreFail({
                    data: '商户名称已存在'
                }))
            }
            else {
                dispatch(actionOperateStoreFail({
                    data: '更新失败'
                }))
            }
            console.log(error)
        }
    }
}

export const ACTION_UPDATESTORE_SUCCESS = 'USER.ACTION_UPDATESTORE_SUCCESS'

export interface ActionUpdateStorePayload {
    data: any
}

export const actionUpdateStoreSuccess = createAction(
    ACTION_UPDATESTORE_SUCCESS,
    (payload: ActionUpdateStorePayload) => {
        return payload;
    }
)

